import { Box } from '@rbilabs/universal-components';

export const hiddenStyles = {
  height: 0,
};

export const hiddenStylesDesktop = {
  height: 0,
  width: 0,
  opacity: 0,
};

export const ProductOverviewContainer = Box.withConfig({
  width: 'full',
});
